import { QUERY_KEY_ENTITY, QUERY_KEY_TYPE } from '../../constants';
import { baseApi } from './base.api';

export const userApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRolesDropdown: build.query({
      query: () => `/v1/users/roles`,
      providesTags: [
        { type: QUERY_KEY_ENTITY.ROLE, id: QUERY_KEY_TYPE.DROPDOWN },
      ],
    }),
    deleteUser: build.mutation({
      query: (ids) => ({
        url: `/v1/users`,
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: (res, err, args) =>
        err
          ? []
          : [
              { type: QUERY_KEY_ENTITY.USER, id: QUERY_KEY_TYPE.LIST },
              ...(args?.length
                ? args.map((id) => ({
                    type: QUERY_KEY_ENTITY.USER,
                    id: Number(id) || 0,
                  }))
                : []),
            ],
    }),
    getUserById: build.query({
      query: (arg) => `/v1/users/${arg}`,
      providesTags: (res, err, args) => [
        { type: QUERY_KEY_ENTITY.USER, id: Number(args) || 0 },
      ],
    }),
    getUsers: build.query({
      query: () => `/v1/users`,
      providesTags: [{ type: QUERY_KEY_ENTITY.USER, id: QUERY_KEY_TYPE.LIST }],
    }),
    updateUser: build.mutation({
      query: ({ id, ...payload }) => ({
        url: id ? `/v1/users/${id}` : '/v1/users',
        method: id ? 'PATCH' : 'POST',
        body: payload,
      }),
      invalidatesTags: (res, err, arg) => [
        { type: QUERY_KEY_ENTITY.USER, id: QUERY_KEY_TYPE.LIST },
        ...(arg.id
          ? [{ type: QUERY_KEY_ENTITY.USER, id: Number(arg.id) || 0 }]
          : []),
      ],
    }),
    getCurrentUser: build.query({
      query: () => ({
        url: '/v1/auth/get-user',
        method: 'POST',
      }),
      transformResponse: ({ user }) => user,
      providesTags: (res) => [
        { type: QUERY_KEY_ENTITY.CURRENT_USER },
        { type: QUERY_KEY_ENTITY.USER, id: Number(res.id) || 0 },
      ],
    }),
    updateCurrentUser: build.mutation({
      query: (payload) => ({
        url: '/v1/users/current',
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: (res, err) =>
        err ? [] : [{ type: QUERY_KEY_ENTITY.CURRENT_USER }],
    }),
    signIn: build.mutation({
      query: (payload) => ({
        url: '/v1/auth/sign-in',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserByIdQuery,
  useGetRolesDropdownQuery,
  useGetCurrentUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useUpdateCurrentUserMutation,
  useSignInMutation,
} = userApi;
